export default {
  setStatuses: (state, statuses) => {
    state.statuses = statuses;
  },

  setAboServices: (state, aboServices) => {
    state.aboServices = aboServices;
  },
};
